// extracted by css-extract-rspack-plugin
export default {"divider":"HeaderDivider-module__divider__VIAtC"};